/* lua.js generated code 0.3.0 */

var HomeSceneAnimBase = require("clover/scene/component/homescene/homeSceneAnim/HomeSceneAnimBase")
var BirdFlock = xClass("BirdFlock", HomeSceneAnimBase)
BirdFlock.prototype.ctor = function () {
    var self = this
    HomeSceneAnimBase.prototype.ctor.call(self)
    self.birds = table()
    self.createBirds()
}
var SHADOW_OFFSETY = 100
var POS_TABLE = table([1, 1, table(
        [0, table([0, -135], 69)],
        [0, table([0, -124], 42.7)],
        [0, table([0, -98], 45)],
        [0, table(42.6, 38)],
        [0, table([0, -45], 1)],
        [0, table([0, -30.6], 9)],
        [0, table([0, -10], [0, -23.6])],
        [0, table(15.7, [0, -2.5])],
        [0, table(33, 13)],
        [0, table(62, 13)],
        [0, table(72, [0, -36])],
        [0, table(97, [0, -29])],
        [0, table(149, [0, -60])]
    )], [1, 2, table(
        [0, table([0, -161], 50)],
        [0, table([0, -133], 37)],
        [0, table([0, -108], 22.6)],
        [0, table([0, -87], [0, -8])],
        [0, table([0, -74], 40)],
        [0, table([0, -66], [0, -12])],
        [0, table([0, -43], 51)],
        [0, table([0, -21], 16)],
        [0, table([0, -2], [0, -25])],
        [0, table(39.75, 25)],
        [0, table(77, [0, -104])],
        [0, table(92, [0, -51])],
        [0, table(107, [0, -90])],
        [0, table(129, [0, -117])]
    )])
BirdFlock.prototype.createBirds = function () {
    var self = this
    self.birdNode = cc.Node.create()
    self.addChild(self.birdNode)
    var index = math.random(2)
    var $limit9 = $len(POS_TABLE[index])
    for (var i = 1; i <= $limit9; i += 1) {
        var sp = cc.Sprite.createWithSpriteFrameName("birds_0000.png")
        var frames = SpriteUtil.buildFrames("birds_%04d.png", 0, 12, false, true)
        var animate = SpriteUtil.buildAnimate(frames, 0.0333, false, true)
        var startTime = math.random(30) / 100
        sp.play(animate, startTime)
        var scale = math.random(40) / 100 + 0.8
        sp.setScale(scale)
        var [posX, posY] = [POS_TABLE[index][i][1], POS_TABLE[index][i][2]]
        sp.setPosition(posX, posY)
        self.birdNode.addChild(sp)
    }
}

BirdFlock.prototype.onEnter = function () {
    HomeSceneAnimBase.prototype.onEnter.call(this)
}

// BirdFlock.prototype.pause = function () {
//     var self = this
//     // FIXME: self.anim
//     //self.anim.pause()
// }
// BirdFlock.prototype.resume = function () {
//     var self = this
//     // FIXME: self.anim
//     //self.anim.resume()
// }
module.exports = BirdFlock
